<!-- 线下保单保函登记及验真生效声明弹框 -->
<template>
    <custom-modal
        width="800px"
        title="材料提供完整性声明"
        :visible="visible"
        @on-close="handleClose"
    >
        <p v-html="content" />
        <template #customFooter>
            <a-button @click.stop="handleClose">不同意</a-button>
            <a-button v-if="timeout > 0" disabled>
                确认并同意（倒计时{{ timeout }}秒）
            </a-button>
            <a-button
                v-else
                type="primary"
                @click.stop="handleOk"
            >
                确认并同意
            </a-button>
        </template>
    </custom-modal>
</template>

<script>
import { Button as AButton } from 'ant-design-vue'
import CustomModal from '@components/CustomModal'

export default {
    name: 'UploadGuaranteeCheckModal',
    components: {
        AButton,
        CustomModal
    },
    data() {
        return {
            visible: false,
            timeout: 0,
            timer: null,
            content: `<p style="margin-left:30px;text-indent:0;padding:0 0 0 0 "><span style="font-family:宋体;font-weight:bold;font-size:16px">1.&nbsp;</span><strong><span style="font-family: 宋体;font-size: 16px">提交</span></strong><strong><span style="font-family: 宋体;font-size: 16px">要求</span></strong></p><p style="padding:0 0 0 0 "><span style=";font-family:宋体;font-size:16px">您</span><span style=";font-family:宋体;font-size:16px">可上传纸质</span><span style=";font-family:宋体;font-size:16px">保函</span><span style=";font-family:宋体;font-size:16px">（含银行保函、</span><span style=";font-family:宋体;font-size:16px">保险保函</span><span style=";font-family:宋体;font-size:16px">等）</span><span style=";font-family:宋体;font-size:16px">的</span><span style=";font-family:宋体;font-size:16px">扫描件，</span><span style=";font-family:宋体;font-size:16px">具体要求如下：</span></p><p style="margin-left:0;text-indent:28px;padding:0 0 0 0 ;text-autospace:ideograph-numeric"><span style="font-family:宋体;font-size:16px">(1)&nbsp;</span><span style=";font-family:宋体;font-size:16px"><span style="font-family:宋体">全页彩色扫描件（分辨率</span><span style="font-family:宋体">≥300dpi），文件格式为PDF/A（长期归档格式），单文件大小不超过50MB；</span></span></p><p style="margin-left:0;text-indent:28px;padding:0 0 0 0 ;text-autospace:ideograph-numeric"><span style="font-family:宋体;font-size:16px">(2)&nbsp;</span><span style=";font-family:宋体;font-size:16px">扫描件须完整包含金融机构公章（含骑缝章）、法定代表人（或授权人）亲笔签名、保函编号、受益人全称、担保金额（大小写一致）、有效期起止日期等核心条款，不得存在模糊、折痕、遮挡或非正常裁切。</span></p><p style="margin-left:30px;text-indent:0;padding:0 0 0 0 "><span style="font-family:宋体;font-weight:bold;font-size:16px">2.&nbsp;</span><strong><span style="font-family: 宋体;font-size: 16px">使用</span></strong><strong><span style="font-family: 宋体;font-size: 16px"><span style="font-family:宋体">责任</span><span style="font-family:宋体"></span></span></strong></p><p style="padding:0 0 0 0 "><span style=";font-family:宋体;font-size:16px">您</span><span style=";font-family:宋体;font-size:16px">承诺并</span><span style=";font-family:宋体;font-size:16px">保证上传的纸质保函扫描件为原始文件完整</span><span style=";font-family:宋体;font-size:16px">扫描</span><span style=";font-family:宋体;font-size:16px"><span style="font-family:宋体">，不得裁剪、遮挡、</span><span style="font-family:宋体">PS修改；若因上传伪造、涂改或已失效的纸质保函导致纠纷，您</span></span><span style=";font-family:宋体;font-size:16px">应</span><span style=";font-family:宋体;font-size:16px">承担全部法律责任。</span></p><p style="margin-left:30px;text-indent:0;padding:0 0 0 0 "><span style="font-family:宋体;font-weight:bold;font-size:16px">3.&nbsp;</span><strong><span style="font-family: 宋体;font-size: 16px"><span style="font-family:宋体">免责声明</span><span style="font-family:宋体"></span></span></strong></p><p style="padding:0 0 0 0 "><span style=";font-family:宋体;font-size:16px">您理解并同意，</span><span style=";font-family:宋体;font-size:16px">本平台</span><span style=";font-family:宋体;font-size:16px">在以下情况下不承担责任（包括但不限于）：</span></p><p style="margin-left:0;text-indent:28px;padding:0 0 0 0 ;text-autospace:ideograph-numeric"><span style="font-family:宋体;font-size:16px">(1)&nbsp;</span><span style=";font-family:宋体;font-size:16px">因</span><span style=";font-family:宋体;font-size:16px">您上传的</span><span style=";font-family:宋体;font-size:16px">纸质</span><span style=";font-family:宋体;font-size:16px">保函</span><span style=";font-family:宋体;font-size:16px">本身印刷错误、公章伪造导致的验真偏差</span><span style=";font-family:宋体;font-size:16px">；</span></p><p style="margin-left:0;text-indent:28px;padding:0 0 0 0 ;text-autospace:ideograph-numeric"><span style="font-family:宋体;font-size:16px">(2)&nbsp;</span><span style=";font-family:宋体;font-size:16px">因</span><span style=";font-family:宋体;font-size:16px">您上传的纸质保函</span><span style=";font-family:宋体;font-size:16px">扫描件模糊、反光、缺页导致的识别错误；</span></p><p style="margin-left:0;text-indent:28px;padding:0 0 0 0 ;text-autospace:ideograph-numeric"><span style="font-family:宋体;font-size:16px">(3)&nbsp;</span><span style=";font-family:宋体;font-size:16px">因</span><span style=";font-family:宋体;font-size:16px">您</span><span style=";font-family:宋体;font-size:16px">未完整上传</span><span style=";font-family:宋体;font-size:16px">纸质</span><span style=";font-family:宋体;font-size:16px">保函</span><span style=";font-family:宋体;font-size:16px">骑缝章页、特别约定附件页导致的结论错误。</span></p><p><br/></p>`
        }
    },
    beforeDestroy() {
        this.clearTimer()
    },
    methods: {
        handleClose() {
            this.visible = false
            this.clearTimer()
        },
        open() {
            this.visible = true
            this.timeout = 15
            this.startCountdown()
        },
        handleOk() {
            this.clearTimer()
            this.$emit('ok')
            this.visible = false
        },
        startCountdown() {
            this.clearTimer()
            this.timer = setInterval(() => {
                if (this.timeout > 0) {
                    this.timeout--
                } else {
                    this.clearTimer()
                }
            }, 1000)
        },
        clearTimer() {
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
        }
    }
}
</script>
